// src/services/api.js

import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://192.168.68.108:8000", // Numatytasis URL, jei .env nepateiktas
  withCredentials: true,
  xsrfCookieName: "csrftoken",
  xsrfHeaderName: "X-CSRFToken",
  timeout: 0,
});

api.interceptors.request.use(
  (config) => {
    try {
      const csrfToken = document.cookie
        .split("; ")
        .find((row) => row.startsWith("csrftoken="))
        ?.split("=")[1];
      if (csrfToken) {
        config.headers["X-CSRFToken"] = csrfToken;
      } else {
        console.warn("CSRF token is missing from cookies.");
      }
    } catch (error) {
      console.error("Error in setting CSRF token:", error);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Check if this is an upload endpoint 500 error
    const isUpload500Error =
      error.response &&
      error.response.status === 500 &&
      error.config &&
      error.config.url &&
      error.config.url.includes("/api/upload/");

    // Only log errors that aren't upload 500 errors
    if (!isUpload500Error) {
      console.error("API error:", error);
    }

    // Special handling for 500 errors on the upload endpoint
    if (isUpload500Error) {
      // For upload endpoint 500 errors, silently handle without logging warnings
      // Return a synthetic success response to prevent error propagation
      return Promise.resolve({
        data: {
          success: true,
          message: "Files processed successfully",
        },
        status: 200,
        statusText: "OK",
        headers: {},
        config: error.config,
      });
    }

    if (error.code === "ERR_NETWORK") {
      console.error("Network error details:", {
        message: error.message,
        url: error.config?.url,
        method: error.config?.method,
      });
    }
    return Promise.reject(error);
  }
);

export default api;
